import { render, staticRenderFns } from "./PendingDPD.vue?vue&type=template&id=d4b1b8c4"
import script from "./PendingDPD.vue?vue&type=script&lang=js"
export * from "./PendingDPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports